// src/printing/qzInit.js
import { initQZSecurity } from './qzSecurity';

export function initQZ() {
  if (!window.qz) {
    console.warn('QZ Tray not loaded');
    return;
  }

  const qz = window.qz;

  // 1. Register security FIRST
  initQZSecurity();

  // 2. Initialize websocket ONCE (lazy-safe)
  if (!qz.websocket.isActive()) {
    console.log('Initializing QZ websocket...');
    qz.websocket.connect()
      .then(() => {
        console.log('QZ websocket initialized');
      })
      .catch(err => {
        console.error('QZ websocket init failed', err);
      });
  }
}
